import VueCookies from 'vue-cookies'
import http, { axiosUpdateHeaders } from '@/http'

const SET_AUTH = 'SET_AUTH'
const RESET_AUTH = 'RESET_AUTH'
const SET_AUTH_COMPANY = 'SET_AUTH_COMPANY'

const initialState = {
  isLoggedIn: VueCookies.get('isLoggedIn') ? VueCookies.get('isLoggedIn') : false,
  user: (window.localStorage.getItem('user') !== 'undefined') ? JSON.parse(localStorage.getItem('user')) : null,
  company: {}
}

export const state = { ...initialState }

export const mutations = {
  [SET_AUTH] (state, payload) {
    const { id, first_name, groups, context_company, companies, completedRegister, password_expired } = payload
    const userGroups = groups.map(group => group.name)
    const user = {
      id,
      first_name,
      completedRegister,
      password_expired,
      isAdmin: userGroups.indexOf('admin') !== -1,
      isAgent: userGroups.indexOf('agent') !== -1,
      isManager: userGroups.indexOf('manager') !== -1,
      groups: userGroups
    }
    /**/
    state.isLoggedIn = true
    state.company = {
      ...context_company
    }
    state.user = {
      ...user,
      companies: companies.map(company => ({
        id: company.id,
        name: company.name,
        logo: company.logo,
        document_number: company.document_number,
        fantasy_name: company.fantasy_name
      }))
    }
    /**/
    // window.localStorage.setItem('user', JSON.stringify(state.user));
    VueCookies.set('isLoggedIn', true)
  },

  [RESET_AUTH] (state) {
    state.isLoggedIn = false
    state.user = null
    state.company = null
    /**/
    VueCookies.remove('isLoggedIn')
    // window.localStorage.removeItem('user')
  },

  [SET_AUTH_COMPANY] (state, payload) {
    state.company = {
      ...payload
    }
  }
}

export const actions = {
  getUserLoggedin ({ commit }) {
    const axios = axiosUpdateHeaders()

    return axios.get('/api/user/loggedin')
      .then(response => {
        if (response.status === 200) {
          commit(SET_AUTH, response.data)
        }

        const maintenance = (response.headers.maintenance && response.headers.maintenance === 'True') ? true : false
        commit('SET_MAINTENANCE', maintenance, { root: true })
        if (maintenance) {
          commit(RESET_AUTH)
        }
      })
      .catch(error => {
        commit(RESET_AUTH)
        const maintenance = (error.response.headers.maintenance && error.response.headers.maintenance === 'True') ? true : false
        commit('SET_MAINTENANCE', maintenance, { root: true })
      })
  },

  postUserLogin ({ commit }, data) {

    return http.post('/api/user/login', data)
      .then(response => {
        // ``response.data.user`` only appears on the legacy/bypass path.
        // The OTP flow returns ``response.data.otp`` and the session is
        // bound by ``postLoginVerify`` after the user enters the code.
        if (response.status === 200 && response.data && response.data.user) {
          commit(SET_AUTH, response.data.user)
        }
        return Promise.resolve(response)
      })
      .catch(error => {
        commit(RESET_AUTH)
        return Promise.reject(error)
      })
  },

  postLoginVerify ({ commit }, data) {

    return http.post('/api/user/login/verify', data)
      .then(response => {
        if (response.status === 200 && response.data && response.data.user) {
          commit(SET_AUTH, response.data.user)
        }
        return Promise.resolve(response)
      })
      .catch(error => {
        return Promise.reject(error)
      })
  },

  postLoginResend (_ctx, data) {

    return http.post('/api/user/login/resend', data)
      .then(response => Promise.resolve(response))
      .catch(error => Promise.reject(error))
  },

  getUserLogout ({ commit }) {

    return http.get('/api/user/logout/')
      .then(response => {
        commit(RESET_AUTH)
        /* CHANGE ROUTE */
        return Promise.resolve(response)
      })
      .catch(error => {
        commit(RESET_AUTH)
        return Promise.reject(error)
      })
  },

  postContextChange ({ commit }, data) {

    return http.post('/api/companies/context/change', data)
      .then(response => {
        if (response.status === 200) {
          commit(SET_AUTH, response.data)
          return Promise.resolve(response)
        }
        return Promise.reject(response.error)
      })
      .catch(error => {
        return Promise.reject(error.response)
      })
  }
}

export default {
  namespaced : true,
  state,
  mutations,
  actions
}
